import { render, staticRenderFns } from "./DemoGuide.vue?vue&type=template&id=7664c56a&scoped=true&"
import script from "./DemoGuide.vue?vue&type=script&lang=js&"
export * from "./DemoGuide.vue?vue&type=script&lang=js&"
import style0 from "./DemoGuide.vue?vue&type=style&index=0&id=7664c56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664c56a",
  null
  
)

export default component.exports